import React from 'react';

const About = () => (
  <section className="page">
    <h1>About</h1>

    <h2>Blueprint Byte</h2>
    <p>
      I’m just a regular guy behind the handle Blueprint Byte. I’ve been through the ringer—financial 
      bankruptcy, barely scraping by, the whole mess. Now I’m building the apps I always wanted, like 
      Hestia Ledger, to help folks like me keep their finances straight without the chaos.
    </p>
    <p>
      This isn’t some polished startup gig—it’s me, a guy who’s been there, making tools that actually 
      work. Hestia Ledger’s my first swing at it, and I’m damn proud to share it.
    </p>

    <h2>Hestia Ledger</h2>
    <p>
      Hestia Ledger is a no-nonsense app for personal and small business financial tracking. It’s built 
      for people who want to log their money, bills, and data without drowning in complexity. Whether 
      you’re a freelancer, a side-hustler, or just trying to stay on top of your own cash, it’s here 
      to keep things simple and systematic.
    </p>
    <p>
      The free version gets you started with an easy input form. The full version unlocks cloud 
      storage, Excel and PDF exports, JSON data management, a calendar, and recurring bills/income 
      tracking. It’s your ledger—own it your way.
    </p>

    <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
  </section>
);

export default About;